import script from "./EnvironmentPreview.vue?vue&type=script&setup=true&lang=js"
export * from "./EnvironmentPreview.vue?vue&type=script&setup=true&lang=js"

import "./EnvironmentPreview.vue?vue&type=style&index=0&id=3504c38f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3504c38f"]])

export default __exports__